export const ADD_ASSETS = "ADD_ASSETS";
export const ADD_ASSET_LOOKUP = "ADD_ASSET_LOOKUP";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const DELETE_ASSET = "DELETE_ASSET";
export const EDIT_ASSET = "EDIT_ASSET";
export const SAVE_ASSET = "SAVE_ASSET";
export const LOAD_ASSET = "LOAD_ASSET";
export const CANCEL_EDIT_ASSET = "CANCEL_EDIT_ASSET";

type AssetsAction = typeof ADD_ASSETS | typeof UPDATE_ASSET | typeof DELETE_ASSET | typeof EDIT_ASSET | typeof SAVE_ASSET | typeof LOAD_ASSET | typeof ADD_ASSET_LOOKUP | typeof CANCEL_EDIT_ASSET;
export interface AssetsPayload {
  type: AssetsAction;
  data: any;
}
